import { NgModule } from '@angular/core';
import { NgFileDropDirective } from '../directives/ng-file-drop.directive';
import { NgFileSelectDirective } from '../directives/ng-file-select.directive';

@NgModule({
   declarations: [
     NgFileSelectDirective,
     NgFileDropDirective
   ],
   exports: [
     NgFileSelectDirective,
     NgFileDropDirective
   ]
})
export class NgUploaderModule {}




// WEBPACK FOOTER //
// ./node_modules/ngx-uploader/src/ngx-uploader/module/ngx-uploader.module.ts